import Tooltip from '@material-ui/core/Tooltip';
import { useMemo } from 'react';
import { useState, useRef } from 'react';
import ColorPicker from './ColorPicker';
import Popover from '@material-ui/core/Popover';
import ScalebarTextPlacementStructure from './ScalebarTextPlacementStructure';
import { convertUnits } from './Units';
export default function ScalebarEditor({
  data,
  onEvent,
}){




  const [ colorPopoverOpen, setColorPopoverOpen ] = useState(false);

  const colorPreviewRef = useRef();

  let { textPosition, style={} } = data;
  let { color="red" } = style;

  const onChange = (properties,e) => {
    onEvent({
      type:"propertyChange",
      properties
    })
  }



  let { computed } = data;
  let isProportionWidth = computed.units === "%";
  let maxValue = isProportionWidth ? 100 : null;



  console.log("max value: "+ maxValue);
  console.log({computed})

  let lengthField = (
    <div>
      <div>Length</div>

      <Tooltip enterDelay={0} placement={"top"} title={"Min. value is 0.01."}>
        <input 
          key={"scalebar-target-length"}
          input={"scalebar-target-length"}
          onChange={e => {


            debugger;

            let properties= {
              "width.value":Number(e.target.value),
              "width.units":computed.units
            }
            //console.log("New value: "+ e.target.value);
            onChange(properties,e)
          }}
          min={1}
          max={ maxValue }
          type="number"
          step={1}
          value={computed.value}
          style={{width:50,fontSize:10}}/>
      </Tooltip>
    </div>

  )

  const unitsSelect = useMemo(() => {

    const unitsOrder = [
      "nm",
      "µm",
      "mm",
      "cm",
      "dm",
      "m",
    ]
    return (

      <select //key={Math.random()}
        style={{
          fontSize:10,
        }}
        input={"scalebar-units"} defaultValue={"μm"} value={computed.units} onChange={e => {

          let newUnit = e.target.value;
          debugger;
          let newValue = Number(convertUnits({
            value:computed.value,
            from:computed.units,
            to:newUnit,

          }).toFixed(3))

          if( newValue > 0.01 ){

            let properties = {
              "width.units":newUnit,
              "width.value":newValue
            }

            onChange(properties,e);
          }
        }}>
        {unitsOrder.map(option => {
          return (
            <option value={option}>
              {option}
            </option>
          )
        })}

      </select>
    )
  },[computed])


  return (

    <div onMouseDown={e => {
      e.stopPropagation();
    }} onClick={e => {
      e.stopPropagation();
    }} style={{width:100}} class="tiny-padding">
      {false && <div>
        <pre>
          {JSON.stringify(data,null,1)}
        </pre>
      </div>}
      <div style={{marginBottom:20}} class="sg-row">
        {lengthField}
        <div style={{marginLeft:10}}>
          <div>Units</div>
          {unitsSelect} 
        </div>


      </div>

      <div class="sg-row v-center small-margin-bottom">
        <div>Color&nbsp;</div>

        <div sidebarMenuItem={"color"} submenu={"scalebar"} ref={colorPreviewRef} onClick={() => {
          setColorPopoverOpen(!colorPopoverOpen);
        }} style={{
          position:'relative',
          width:20,
          height:20,
          borderRadius:2,
          background:(data.style.color),
          border:'1px solid #aaa',
        }}>


        </div>

        {colorPopoverOpen && <Popover
          style={{ 
            zIndex:0,
            transform:'translate(-40px,0)',
            //width:240,
          }}
          className={"style-toolbar"}
          open={true}
          anchorEl={colorPreviewRef.current}
          onClose={() => setColorPopoverOpen(false)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div style={{position:'relative', width:240, zIndex:999999999999 }}>
            <ColorPicker {...{
              onChange:color => {
                let properties = {
                  "style.color":color
                }
                onChange(properties);
                setColorPopoverOpen(false);
              },
              color:data.style.color,
            }}/> 
          </div>
        </Popover>}

      </div>


      {false && <div>
        <div>Whiskers length</div>
        <div><input value={data.whiskers} onChange={e => {
          let propeties = {
            whiskers:Number(e.target.value)
          }
          onChange(propeties,e)
        }} style={{width:40, fontSize:10,}} type="number"/></div>
      </div>}


      <ScalebarTextPlacementStructure {...{onEvent:onChange,textPosition,data}}/>






    </div>


  )


}


